import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

import ListingPrediction from 'components/project/listing_prediction';
import ListingRollupSummary from './listing_rollup_summary';
import ProjectCard from 'components/project/project_card';
import EmptyState from 'components/project/empty_state';

export default class PredictionsCard extends React.Component {
  static propTypes = {
    condoListings: PropTypes.arrayOf(PropTypes.shape({
      listingStatus: PropTypes.string
    })),
    editLink: PropTypes.string,
    features: PropTypes.shape({
      backoffice: PropTypes.bool,
      pipeline: PropTypes.bool,
    }).isRequired,
    leaseListings: PropTypes.arrayOf(PropTypes.shape({
      listingStatus: PropTypes.string
    })),
    listing: PropTypes.shape({
      dateLikelyToClose: PropTypes.string,
      estimatedGrossCommission: PropTypes.number,
      listingStatus: PropTypes.string.isRequired,
      percentageLikelyToClose: PropTypes.number,
      type: PropTypes.string.isRequired
    }),
    lotListings: PropTypes.arrayOf(PropTypes.shape({
      listingStatus: PropTypes.string
    })),
    showModal: PropTypes.func
  };

  hasLeaseSpaceListings = () => (this.props.leaseListings || []).length > 0

  hasLotListings = () => (this.props.lotListings || []).length > 0

  hasCondoListings = () => (this.props.condoListings || []).length > 0

  showModal = (e) => {
    e.preventDefault();
    this.props.showModal();
  }

  cardTitle = () => `${this.props.listing && this.props.listing.type === 'SaleListing' ? 'Sale ' : ''}Prediction`;

  renderRollup(listings, type) {
    const { editLink, features } = this.props;
    return (
      <ListingRollupSummary
        editLink={editLink}
        features={features}
        listings={listings}
        listingType={type}
      />
    );
  }

  render() {
    const {
      condoListings,
      editLink,
      features,
      listing,
      lotListings,
      leaseListings
    } = this.props;
    const hasRollupListings = this.hasLeaseSpaceListings() || this.hasLotListings() || this.hasCondoListings();

    if (hasRollupListings || listing) {
      return (
        <Panel>
          {listing &&
            <div className="mb-4">
              <ListingPrediction
                editLink={editLink}
                features={features}
                listing={listing}
                showUpdateModal={this.showModal}
                title={this.cardTitle()}
              />
            </div>
          }

          {listing && hasRollupListings && <hr className="m-0" />}

          {this.hasCondoListings() && this.renderRollup(condoListings, 'Condo')}
          {this.hasLotListings() && this.renderRollup(lotListings, 'Lot')}
          {this.hasLeaseSpaceListings() && this.renderRollup(leaseListings, 'Lease Space')}
        </Panel>
      );
    }

    return (
      <ProjectCard className="dynamic-height overview-panel position-relative" name={this.cardTitle()}>
        <EmptyState
          imageSrc="/images/project_empty_states/predictions.svg"
          message="Availability Type must be selected to enter a Prediction."
        />
      </ProjectCard>
    );
  }
}
